import { useEffect, useState } from 'react';
import { clientDirectoryApi } from './client-directory-api';
import { BusinessLogo } from './BusinessLogo';
export interface HostingClientChoice {
  readonly id: string;
  readonly displayName: string;
  readonly hasLogo: boolean;
  readonly version: number;
}
export function HostingClientPicker({
  value,
  onChange,
}: {
  readonly value: HostingClientChoice | null;
  readonly onChange: (client: HostingClientChoice | null) => void;
}): React.JSX.Element {
  const [search, setSearch] = useState(''),
    [page, setPage] = useState(0),
    [visit, setVisit] = useState(0),
    [items, setItems] = useState<readonly HostingClientChoice[]>([]),
    [total, setTotal] = useState(0),
    [loading, setLoading] = useState(true),
    [error, setError] = useState(false);
  useEffect(() => {
    let active = true;
    setLoading(true);
    setError(false);
    const timer = window.setTimeout(() => {
      void clientDirectoryApi
        .search(search, page, 'clients')
        .then(
          (result) => {
            if (active) {
              setItems(
                result.clients.filter(
                  (client) =>
                    client.stage === 'CLIENT' && client.origin !== 'FREEBE_LEGACY_UNREVIEWED',
                ),
              );
              setTotal(result.clientCount);
            }
          },
          () => {
            if (active) {
              setError(true);
              setItems([]);
            }
          },
        )
        .finally(() => {
          if (active) setLoading(false);
        });
    }, 200);
    return () => {
      active = false;
      window.clearTimeout(timer);
    };
  }, [search, page, visit]);
  return (
    <div className="hosting-servers-editor__client">
      <p>Client choisi : {value?.displayName ?? 'Aucun'}</p>
      {value ? (
        <button type="button" onClick={() => onChange(null)}>
          Détacher le Client
        </button>
      ) : null}
      <label>
        Rechercher un Client
        <input
          value={search}
          maxLength={120}
          onChange={(event) => {
            setSearch(event.target.value);
            setPage(0);
          }}
        />
      </label>
      {loading ? (
        <p role="status">Recherche des Clients…</p>
      ) : error ? (
        <p className="tosho-feedback is-error" role="alert">
          Le répertoire Client ne répond pas.{' '}
          <button type="button" onClick={() => setVisit((n) => n + 1)}>
            Réessayer
          </button>
        </p>
      ) : (
        <>
          <ul aria-label="Clients disponibles">
            {items.map((client) => (
              <li key={client.id}>
                <button
                  type="button"
                  aria-label={'Choisir ' + client.displayName}
                  aria-pressed={value?.id === client.id}
                  onClick={() => onChange(client)}
                >
                  <BusinessLogo
                    name={client.displayName}
                    logoUrl={
                      client.hasLogo
                        ? `/api/clients/${encodeURIComponent(client.id)}/logo?v=${client.version}`
                        : null
                    }
                  />
                </button>
              </li>
            ))}
          </ul>
          {!items.length ? <p>Aucun Client dans ces résultats.</p> : null}
          <div className="hosting-servers-editor__client-pages">
            <button type="button" disabled={page === 0} onClick={() => setPage((n) => n - 1)}>
              Clients précédents
            </button>
            <span>Page {page + 1}</span>
            <button
              type="button"
              disabled={(page + 1) * 20 >= total}
              onClick={() => setPage((n) => n + 1)}
            >
              Clients suivants
            </button>
          </div>
        </>
      )}
    </div>
  );
}
